<div class="sidebar-container no-print" [class.collapsed]="isCollapsed">
  
  <!-- Logo -->
  <div class="sidebar-header">
    <img src="{{this.environment.assets.logo}}" width="120" alt="Logo Bhavani" class="logo" *ngIf="!isCollapsed">
    <button class="close-menu-btn" (click)="toggleSidebar()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 3V21M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z" stroke="#332C26" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <!-- Menú principal -->
  <ul class="menu-section">
    <ng-container *ngFor="let item of navLinks">
      <li *ngIf="this.checkRoles(item?.includes,item?.excludes)">
        <ng-container *ngIf="item.href.length > 0" >
          <a [routerLink]="item.href" routerLinkActive="active">
            <img *ngIf="item.icon" [src]="item.icon" alt="{{ item.title }}" class="menu-icon" />
            <span class="menu-text" *ngIf="!isCollapsed">{{ item.title }}</span>
          </a>
        </ng-container>
        <ng-container *ngIf="item.href.length === 0" >
          <div class="anclaFake">
            <img *ngIf="item.icon" [src]="item.icon" alt="{{ item.title }}" class="menu-icon" />
            <span class="menu-text" *ngIf="!isCollapsed">{{ item.title }}</span>
          </div>
        </ng-container>
        <ul *ngIf="item?.childs?.length > 0">
          <ng-container *ngFor="let navItem of item.childs">
            <li role="menuitem" class="nav-item" *ngIf="this.checkRoles(navItem?.includes,navItem?.excludes)">
              <a
                class="nav-link text-start" 
                [routerLink]="navItem.href" 
                routerLinkActive="active"
              >
                <img *ngIf="navItem.icon" [src]="navItem.icon" alt="{{ navItem.title }}" class="menu-icon" />
                <span class="menu-text">{{navItem.title}}</span>
              </a>
            </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>

  <!-- Separador -->
  <div class="menu-separator"></div>

  <!-- Menú inferior -->
  <ul class="bottom-section">
    <ng-container *ngFor="let item of bottomMenuItems">
      <li *ngIf="this.checkRoles(item?.includes,item?.excludes)">
        <a [routerLink]="item.href" routerLinkActive="active">
          <img [src]="item.icon" alt="{{ item.title }}" class="menu-icon" />
          <span class="menu-text" *ngIf="!isCollapsed">{{ item.title }}</span>
        </a>
      </li>
    </ng-container>
    <li>
      <a (click)="signOut()">
        <img src="assets/svgs/logout_nav.svg" alt="Logout" class="menu-icon" />
        <span class="menu-text" i18n>Salir</span>
      </a>
    </li>
  </ul>

</div>

<div class="BhavaniMenuMobile no-print">
  <ul>
    <ng-container *ngFor="let item of mobileNavLinks">
      <li *ngIf="this.checkRoles(item?.includes,item?.excludes)">
        <ng-container>
          <a [routerLink]="item.href" routerLinkActive="active">
            <img *ngIf="item.icon" [src]="item.icon" alt="{{ item.title }}" class="menu-icon" />
          </a>
        </ng-container>
      </li>
    </ng-container>
    <ng-container *ngFor="let item of mobileBottomMenuItems">
      <li *ngIf="this.checkRoles(item?.includes,item?.excludes)">
        <ng-container>
          <a [routerLink]="item.href" routerLinkActive="active">
            <img *ngIf="item.icon" [src]="item.icon" alt="{{ item.title }}" class="menu-icon" />
          </a>
        </ng-container>
      </li>
    </ng-container>
    <li>
      <a role="button" (click)="toggleSidebar()">
        <img src="assets/svgs/hamburgues_nav.svg"class="menu-icon" />
      </a>
    </li>
  </ul>
</div>
<div 
  class="menu-backdrop no-print" 
  *ngIf="!isCollapsed && isMobile"
  (click)="toggleSidebar()">
</div>
